import { render } from "./SlideshowEdit.vue?vue&type=template&id=1ec195a8&scoped=true"
import script from "./SlideshowEdit.vue?vue&type=script&lang=js"
export * from "./SlideshowEdit.vue?vue&type=script&lang=js"

import "./SlideshowEdit.vue?vue&type=style&index=0&id=1ec195a8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec195a8"]])

export default __exports__